//```import constants types
import {
    VIDFLEET_CONFIGURATION_UPLOAD_MODE_LOAD,
    VIDFLEET_CONFIGURATION_UPLOAD_MODE_LOAD_RESULT,
    VIDFLEET_CONFIGURATION_UPLOAD_MODE_SAVE,
    VIDFLEET_CONFIGURATION_UPLOAD_MODE_SAVE_RESULT,
    VIDFLEET_CONFIGURATION_UPLOAD_MODE_HIDE,
    CLEAR_REDUX
} from "Redux/actionTypes";

//```Initial state
const INIT_STATE = {
    openModal: false,
    loading: false,
    saveResult: null,
    data: null,
    error: {}
};

/**
 * Cases for change properties for objet `listCustomers`
 */
export default (state = INIT_STATE, action) => {
    switch (action.type) {

        case VIDFLEET_CONFIGURATION_UPLOAD_MODE_LOAD:
            const { pagging } = action.payload
            return { ...state, loading: true, data: null, openModal: true };

        case VIDFLEET_CONFIGURATION_UPLOAD_MODE_LOAD_RESULT:
            return { ...state, loading: false, data: action.payload, openModal: true };

        case VIDFLEET_CONFIGURATION_UPLOAD_MODE_SAVE:
            return { ...state, loading: true, saveResult: null };

        case VIDFLEET_CONFIGURATION_UPLOAD_MODE_SAVE_RESULT:
            return { ...state, loading: false, saveResult: action.payload };

        case VIDFLEET_CONFIGURATION_UPLOAD_MODE_HIDE:
            return { ...INIT_STATE, openModal: false, loading: false, saveResult: null, data: null };

        case CLEAR_REDUX:
            return ["", "CONFIGURATION_UPLOAD_MODE"].includes(action.payload.option)
                ? action.payload.parameters ? { ...state, ...action.payload.parameters } : { ...INIT_STATE }
                : { ...state }

        default:
            return state;
    }
};